export default {
  API_URL: process.env.API_URL,
  IMAGE_URL: process.env.IMAGE_URL,
  RPOJECT_URL: process.env.RPOJECT_URL,
  DETAIL_URL: process.env.DETAIL_URL,
  WXSIGN_API: process.env.WXSIGN_API,
  APPID: process.env.APPID,
  MB_CASE_URL: process.env.MB_CASE_URL,
  URL_PREFIX: process.env.URL_PREFIX,
  URL_PHOTO_FINISH: process.env.URL_PHOTO_FINISH,
  ISDOMAIN: process.env.ISDOMAIN,
  API_URL2: process.env.API_URL2,
  NEW_API_URL: process.env.NEW_API_URL,
  LANDPAGE_URL: process.env.LANDPAGE_URL,
  HOTEL_API: process.env.HOTEL_API,
  SENDMSG_URL: process.env.SENDMSG_URL,
  SURVEY_URL: process.env.SURVEY_URL,
  VUE_APP_IMG_HOST: process.env.VUE_APP_IMG_HOST,
  ASSETS_PUBLIC_PATH: process.env.ASSETS_PUBLIC_PATH
};



// WEBPACK FOOTER //
// ./src/config/api.js